import { NgModule } from '@angular/core';
import { WorkerStaticDataComponent } from './worker-static-data.component';

@NgModule({
  imports: [WorkerStaticDataComponent],
  exports: [WorkerStaticDataComponent],
})
export class WorkerStaticDataModule {}
